import '../assets/css/menuButton.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom';


const MenuButton = (props) => {

    return (
        <div className={"menu_btn_container " + (props.isActive ? "activeBtn" : "")}>
            <span className="menu_btn_label_container">
                <span className={"menu_btn_label"}> {props.label !== undefined ? props.label : ""}</span>
            </span>
            {props.icon !== undefined ?
                <Link className={"link_style"} to={props.to}>
                    <FontAwesomeIcon icon={props.icon} />
                </Link>
                :
                props.label !== undefined ? props.label : "B"
            }
        </div>
    )
}

export default MenuButton;